import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=28979072"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28979072')) {
      api.createRecord('28979072', component.options)
    } else {
      api.reload('28979072', component.options)
    }
    module.hot.accept("./ProgressBar.vue?vue&type=template&id=28979072", function () {
      api.rerender('28979072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/usage/ProgressBar.vue"
export default component.exports